"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Forms/useComposerSendForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _common = require('shared/selectors/blobject/common/common');
var _peers = require('shared/selectors/peers');
var _features = require('shared/selectors/org/features');

var _uuid = require('shared/services/uuid');




var _SendFormSheet = require('./SendFormSheet'); var _SendFormSheet2 = _interopRequireDefault(_SendFormSheet);
var _sendFormRequests = require('./sendFormRequests');

/* What + › Send a form needs to know about a chat. */







/* Read by the screen's connected wrapper (compare with shallowEqual). */
 const selectFormsComposerChat = (
  state, blobjectKey, orgKey,
) => {
  const blobject = _common.selectBlobjectByKey.call(void 0, state, blobjectKey)
  // SAFETY: PatientSubscribers is keyed by PatientKey.
  const patientKeys = blobject && blobject.WrappedType !== 'chat'
    ? Object.keys(blobject.PatientSubscribers || {}) 
    : []
  const only = patientKeys.length === 1 ? patientKeys[0] : undefined
  return {
    hasForms: !!orgKey && orgKey !== _uuid.EMPTY_BLUID && _features.selectOrgHasForms.call(void 0, state, orgKey),
    patientCount: patientKeys.length,
    recipientName: only ? _optionalChain([_peers.selectAllPatients.call(void 0, state), 'optionalAccess', _ => _[only], 'optionalAccess', _2 => _2.Name]) || '' : '',
  }
}; exports.selectFormsComposerChat = selectFormsComposerChat

const NO_CHAT = { hasForms: false, patientCount: 0, recipientName: '' }







const NO_HANDLERS = Object.freeze({})

/* + › Send a form in a chat's composer: the handler (only in an org with
 * Forms), the chat's patient count for the registry, and the sheet. */
 const useComposerSendForm = ({ orgKey, conversationKey, chat = NO_CHAT }) => {
  const { hasForms, patientCount, recipientName } = chat

  // undefined: closed; '': open with nothing picked; else the form to start on.
  const [openOn, setOpenOn] = _react.useState(undefined)
  const open = _react.useCallback.call(void 0, (formKey) => setOpenOn(_nullishCoalesce(formKey, () => ( ''))), [])
  const close = _react.useCallback.call(void 0, () => setOpenOn(undefined), [])
  const enabled = hasForms && patientCount === 1
  _react.useEffect.call(void 0, () => { setOpenOn(undefined) }, [conversationKey])
  _react.useEffect.call(void 0, () => enabled ? _sendFormRequests.registerSendFormOpener.call(void 0, conversationKey, open) : undefined, [enabled, conversationKey, open])

  const openFromMenu = _react.useCallback.call(void 0, () => open(), [open])
  const actionHandlers = _react.useMemo.call(void 0, 
    () => hasForms && patientCount > 0 ? { sendForm: openFromMenu } : NO_HANDLERS,
    [hasForms, patientCount, openFromMenu],
  )

  const sheet = openOn !== undefined && orgKey && enabled
    ? (
      _react2.default.createElement(_SendFormSheet2.default, {
        orgKey: orgKey,
        conversationKey: conversationKey,
        recipientName: recipientName,
        initialFormKey: openOn || undefined,
        onClose: close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
      )
      )
    : null

  return { actionHandlers, patientCount, sheet }
}; exports.useComposerSendForm = useComposerSendForm
